import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enResource from './locales/strings-en';
import jaResource from './locales/strings-ja';
import { supportedLocales } from './locales/supportedLocales';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: enResource,
      },
      ja: {
        translation: jaResource,
      },
    },
    lng: 'en',
    fallbackLng: 'en',
    nonExplicitWhitelist: true,
    returnEmptyString: false,
    whitelist: supportedLocales,

    debug: false,

    keySeparator: '.',

    interpolation: {
      escapeValue: false, // react already safes from xss
    },

    returnNull: false,
    returnObjects: true,
  });

export default i18n;
